var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSportHockey24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sport_hockey24x24",
    transform: "translate(1559.994 332)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45726",
    d: "M-1544.144-328.162l-2.045-2.038a.531.531,0,0,1-.089.354.532.532,0,0,1-.089.354,3.821,3.821,0,0,1-.089.443c0,.177-.089.266-.089.443-.089.177-.089.354-.178.532s-.089.266-.178.443l-.267.532c-.089.177-.178.266-.267.443a3.849,3.849,0,0,0-.356.62c-.089.177-.178.266-.266.443-.178.177-.267.443-.445.62-.089.089-.178.266-.267.354-.178.266-.356.443-.533.709a1.224,1.224,0,0,0-.267.354,5.091,5.091,0,0,1-.978.975,5.088,5.088,0,0,0-.978.975c-.089.089-.267.177-.356.354a3.863,3.863,0,0,0-.622.532c-.178.089-.266.177-.444.266-.178.177-.445.266-.622.443-.178.089-.267.177-.444.266s-.356.266-.533.354-.267.177-.444.266l-.533.266c-.178.089-.267.089-.444.177a1.267,1.267,0,0,1-.533.177,3.853,3.853,0,0,1-.444.089,3.857,3.857,0,0,0-.444.089.535.535,0,0,0-.356.089.674.674,0,0,0-.356.089l2.045,2.038c.978.975,4.622-.354,8.178-3.81h0C-1544.411-323.555-1543.078-327.188-1544.144-328.162Z",
    transform: "translate(-.208 -.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45727",
    d: "M-1547.272-330.665a1.338,1.338,0,0,0-.356-.979h0a1.339,1.339,0,0,0-.979-.356h0c-1.78,0-4.628,1.691-7.209,4.183a17.147,17.147,0,0,0-3.649,5.073c-.623,1.424-.712,2.581-.178,3.115a1.338,1.338,0,0,0,.979.356c1.78,0,4.628-1.691,7.209-4.183S-1547.272-328.885-1547.272-330.665Zm-9.078,7.743h0a2.865,2.865,0,0,1-1.6,1.068.68.68,0,0,1-.445-.178c-.534-.445-.178-1.424.445-2.225.623-.712,1.513-1.335,2.047-.89s.178,1.513-.445,2.225Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSportHockey24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_sport_hockey24x24.95bbe66cfe7688d66ce39f7942fa2048.svg";